import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const FilterOptions = ({ name, data, filters, setFilters }) => {
    const isShowMore = data.slice(5).some((f) => filters.includes(f.name));
    //check if any selected filter exists in the filtersData (except first 5 who are already shown)
    const [showMore, setShowMore] = useState(isShowMore);
    const { t } = useTranslation(["glossary"])


    //we need to useEffect because of preserveState true of inertia ( we need to change ShowMore State)
    useEffect(() => {
        setShowMore(isShowMore);
    }, [data]);

    const displayedFilters = showMore === true ? data : data.slice(0, 5);

    const handleFilterChange = (item) => {
        const updatedFilters = new Set(filters);
        if (updatedFilters.has(item.slug.key)) {
            updatedFilters.delete(item.slug.key);
        } else {
            updatedFilters.add(item.slug.key);
        }

        setFilters([...updatedFilters]);
    };

    return (
        <div className="mb-4 text-[#1D26CA]">
            <div className="flex">
                <h3 className="font-semibold mb-2 text-xl text-[#1D26CA]">
                    {name}
                </h3>
                <div className="w-28 ml-6 h-[3px] mt-3.5 bg-[#1D24CA]"></div>
            </div>
            <div>
                {displayedFilters.map((item, index) => (
                    <label
                        className="flex items-center mb-2"
                        key={`${item}-${index}`}
                    >
                        <input
                            type="checkbox"
                            className="mr-2 rounded-sm text-[#1D26CA]"
                            checked={filters.includes(item.slug?.key)}
                            onChange={() => {
                                handleFilterChange(item);
                            }}
                        />
                        {item.name}
                    </label>
                ))}
                {data.length > 5 && (
                    <button
                        title={showMore === true ? t('show-less') : t('show-more')}
                        className="text-[#1D26CA] hover:underline mt-2"
                        onClick={() => setShowMore(!showMore)}
                    >
                        {showMore === true ? t('show-less') : t('show-more')}
                    </button>
                )}
            </div>
        </div>
    );
};

export default FilterOptions;
